import { render } from "./SliderEditPage.vue?vue&type=template&id=f8d7d5b8"
import script from "./SliderEditPage.vue?vue&type=script&lang=js"
export * from "./SliderEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__